import React from 'react'
import Hubnav from '../Hubnav'
import { useState } from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import axios from 'axios'
import BaseURL from '../../Util/BaseURL';
const HubOrders = () => {
    var nav = useNavigate()
    const [orders,setorders]=useState()
    async function getOrderDetails(props) {
      const r = await axios.get(`${BaseURL}getAllOrdersByHub?name=${props}`, { headers: { "Authorization": "Bearer " + sessionStorage.getItem("pic") } })
      setorders(r.data)
  }
const [name,setName]=useState()
   const init=async()=>{
    const res=await axios.get(`${BaseURL}FindByName?name=${sessionStorage.getItem("user")}`)
    getOrderDetails(res.data[0].name)
}
function ordersummary(props){
   nav('/DistributionHubPanel/HubOrders/HubOrderSummary', { state: { orderNo: props} })
   
}
useEffect(() => {
    init()
  },[]);
  return (
    <>
    <Hubnav/>
    <section id="hero">
                 <div className="hero-container">
                     <div className="hero-logo">
                         <h1 className="font-weight-bold">Hub Orders</h1>
                     </div>
                 </div>
            </section>
            <section className="">
                <div className="container">
                    <div className="cart">
                        <div className="table-responsive">
                            <table className="table">
                                <thead className="thead-dark tableH">
                                    <tr >
                                        <th scope="col" className="text-white ">Order Number</th>
                                        <th scope="col" className="text-white ">Date</th>
                                        <th scope="col" className="text-white ">Total Amount</th>
                                        <th scope="col" className="text-white ">Total Discount</th>
                                        <th scope="col" className="text-white ">Delivery Address</th>
                                        <th scope="col" className="text-white ">Payment Method</th>
                                        <th scope="col" className="text-white ">Payment Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                 {orders ? orders.map((data ,key) => (
                                    <tr key={key} className='orderslist target' onClick={()=>ordersummary(data.orderNumber)}>
                                        <td className="productId">{data.orderNumber}</td>
                                        <td className='quantity'>{data.date.substring(5,16)}</td>
                                        <td className="total">{data.totalAmount}</td>
                                        <td className="total">{data.totalDiscount}</td>
                                        <td className="total">{data.address}</td>
                                        <td className="total">{data.payment}</td>
                                        <td className="pay">{data.isBilled === true?<>Paid</>:<>Unpaid</>}</td>
                                    </tr>
                                     )) : <></>} 
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                </section>
    </>
  )
}

export default HubOrders